// React
import { useMemo } from 'react'

// Antd
import { Grid } from 'antd'

const useBreakpoint = () => {
  // Hook
  const { md, lg, xl, xxl } = Grid.useBreakpoint()
  const breakpoint = useMemo((): { isMobile: boolean; isDesktop: boolean; isBigScreen: boolean } => {
    return {
      isMobile: !lg || false,
      isDesktop: md || lg || xl || xxl || false,
      isBigScreen: xl || xxl || false,
    }
  }, [md, lg, xl, xxl])

  return breakpoint
}

export { useBreakpoint }
